import type { ICustomSection } from '@/app/types/types'
import type { PublicCareerConfigPayloadSchema } from '@/generated/api-client'
import { getCompanySlugPublicCareerConfigOptions } from '@/generated/api-client/@tanstack/react-query.gen'
import { useQuery } from '@tanstack/react-query'

export type CareerConfig = Omit<PublicCareerConfigPayloadSchema, 'applicationForm'> & { applicationForm: ICustomSection[] }

/**
 * Public career config for a company slug (logo, career flags, application form, job field labels) —
 * `GET /api/{companySlug}/public/career/config`, never the session. One cached query shared by the
 * career header, jobs list and apply pages.
 */
export function useCareerConfig(companySlug: string | undefined) {
    return useQuery({
        ...getCompanySlugPublicCareerConfigOptions({ path: { companySlug: companySlug ?? '' } }),
        select: (res) => res.data as CareerConfig,
        enabled: Boolean(companySlug),
        staleTime: 5 * 60 * 1000,
    })
}
